import { questionCategories } from "../data/QuestionData";
import { QuestionIds } from "../data/QuestionPresentation";
import { INSURANCELOSS_DEFAULT_ANSWER_ID } from "../data/QuestionData";

export const findQuestionsByCategory = (questionGroups, category) =>
  questionGroups?.find((group) => group.category === category)?.questions;

export const findQuestionById = (questions, id) =>
  questions?.find((question) => question.id === parseInt(id));

export const shouldDisableInsuranceAssumptionAnswer = (formattedQuestions) => {
  const assumptionQuestions = findQuestionsByCategory(
    formattedQuestions,
    questionCategories.ASSUMPTION
  );
  const insuranceAssumptionQuestion = findQuestionById(
    assumptionQuestions,
    QuestionIds.INSURANCELOSS
  );

  if (!insuranceAssumptionQuestion) {
    return false;
  }

  const selectedAnswers = insuranceAssumptionQuestion.selectedAnswers || [];
  return !selectedAnswers.includes(INSURANCELOSS_DEFAULT_ANSWER_ID);
};